module.exports = __webpack_public_path__ + "img/4.ca700da9.png";